import type { FetchEventsQuery } from 'src/__generated__/graphql';
import RowTable from './RowTable';
import { GroupedEvent } from '../data/types';

// Tipo query-scoped: los eventos crudos que trae FETCH_EVENTS (sin `count`, que solo
// aplica a los agrupados). No usar el EventPoint del schema, que exige `count`.
type RawEventPoint = FetchEventsQuery['device']['metrics']['events']['data'][number];

interface Props {
  items: RawEventPoint[] | GroupedEvent[],
  page: number,
  rowsPerPage: number,
  grouped: boolean,
  deviceId: string,
}

const BodyTable = ({ items, page, rowsPerPage, grouped, deviceId }: Props) => {
  const offset = page * rowsPerPage;
  return items
    .slice(offset, offset + rowsPerPage)
    .map((row, index) => <RowTable key={'event-' + index} grouped= {grouped} deviceId={deviceId} userId={(row as RawEventPoint)?.userId ?? ''} {...row} />);
};

export default BodyTable;
